var _style, _path, _path2, _path3, _path4, _ellipse, _defs, _clipPath, _path5, _defs2, _clipPath2, _ellipse2, _defs3, _clipPath3, _path6, _defs4, _clipPath4, _ellipse3, _path7, _defs5, _clipPath5, _path8, _ellipse4, _path9;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgRsSchoolJs = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "rs_school_js_svg__Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 552.8 205.3"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".rs_school_js_svg__st0{fill:#fff}.rs_school_js_svg__st5,.rs_school_js_svg__st7{fill:#fff;stroke:#000;stroke-width:4;stroke-miterlimit:10}.rs_school_js_svg__st7{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m285.4 68 26.3-1.7c.6 4.3 1.7 7.5 3.5 9.8 2.9 3.6 6.9 5.4 12.2 5.4 3.9 0 7-.9 9.1-2.8 2-1.5 3.2-3.9 3.2-6.4 0-2.4-1.1-4.7-3-6.2-2-1.8-6.7-3.6-14.1-5.2-12.1-2.7-20.8-6.3-25.9-10.9-5.1-4.3-8-10.6-7.8-17.3 0-4.6 1.4-9.2 4-13 3-4.3 7.1-7.7 12-9.6 5.3-2.3 12.7-3.5 22-3.5 11.4 0 20.1 2.1 26.1 6.4 6 4.2 9.6 11 10.7 20.3l-26 1.5c-.7-4-2.1-6.9-4.4-8.8s-5.3-2.8-9.2-2.8c-3.2 0-5.6.7-7.2 2-1.5 1.2-2.5 3-2.4 5 0 1.5.8 2.9 2 3.8 1.3 1.2 4.4 2.3 9.3 3.3 12.1 2.6 20.7 5.2 26 7.9 5.3 2.7 9.1 6 11.4 9.9 2.4 4 3.6 8.6 3.5 13.3 0 5.6-1.6 11.2-4.8 15.9-3.3 4.9-7.9 8.7-13.3 11-5.7 2.5-12.9 3.8-21.5 3.8-15.2 0-25.7-2.9-31.6-8.8S286.1 77 285.4 68zM6.3 97.6V8.2h46.1c8.5 0 15.1.7 19.6 2.2 4.4 1.4 8.3 4.3 10.9 8.2 2.9 4.3 4.3 9.3 4.2 14.5.3 8.8-4.2 17.2-11.9 21.6-3 1.7-6.3 2.9-9.7 3.5 2.5.7 5 1.9 7.2 3.3 1.7 1.4 3.1 3 4.4 4.7 1.5 1.7 2.8 3.6 3.9 5.6l13.4 25.9H63L48.2 70.2c-1.9-3.5-3.5-5.8-5-6.9-2-1.4-4.4-2.1-6.8-2.1H34v36.3H6.3zM34 44.4h11.7c2.5-.2 4.9-.6 7.3-1.2 1.8-.3 3.4-1.3 4.5-2.8 2.7-3.6 2.3-8.7-1-11.8-1.8-1.5-5.3-2.3-10.3-2.3H34v18.1zM0 174.2l26.3-1.7c.6 4.3 1.7 7.5 3.5 9.8 2.8 3.6 6.9 5.5 12.2 5.5 3.9 0 7-.9 9.1-2.8 2-1.6 3.2-3.9 3.2-6.4 0-2.4-1.1-4.7-3-6.2-2-1.8-6.7-3.6-14.2-5.2-12.1-2.7-20.8-6.3-25.9-10.9-5.1-4.3-8-10.6-7.8-17.3 0-4.6 1.4-9.2 4-13 3-4.3 7.1-7.7 12-9.6 5.3-2.3 12.7-3.5 22-3.5 11.4 0 20.1 2.1 26.1 6.4s9.5 11 10.6 20.3l-26 1.5c-.7-4-2.1-6.9-4.4-8.8-2.2-1.9-5.3-2.8-9.2-2.7-3.2 0-5.6.7-7.2 2.1-1.6 1.2-2.5 3-2.4 5 0 1.5.8 2.9 2 3.8 1.3 1.2 4.4 2.3 9.3 3.3 12.1 2.6 20.7 5.2 26 7.9 5.3 2.7 9.1 6 11.4 9.9 2.4 4 3.6 8.6 3.6 13.2 0 5.6-1.7 11.1-4.8 15.8-3.3 4.9-7.9 8.7-13.3 11-5.7 2.5-12.9 3.8-21.5 3.8-15.2 0-25.7-2.9-31.6-8.8-5.9-6-9.2-13.4-10-22.4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m133 167.2 24.2 7.3c-1.3 6.1-4 11.9-7.7 17-3.4 4.5-7.9 8-13 10.3-5.2 2.3-11.8 3.5-19.8 3.5-9.7 0-17.7-1.4-23.8-4.2-6.2-2.8-11.5-7.8-16-14.9-4.5-7.1-6.7-16.2-6.7-27.3 0-14.8 3.9-26.2 11.8-34.1s19-11.9 33.4-11.9c11.3 0 20.1 2.3 26.6 6.8 6.4 4.6 11.2 11.6 14.4 21l-24.4 5.4c-.6-2.1-1.5-4.2-2.7-6-1.5-2.1-3.4-3.7-5.7-4.9-2.3-1.2-4.9-1.7-7.5-1.7-6.3 0-11.1 2.5-14.4 7.6-2.5 3.7-3.8 9.6-3.8 17.6 0 9.9 1.5 16.7 4.5 20.4 3 3.7 7.2 5.5 12.7 5.5 5.3 0 9.3-1.5 12-4.4 2.7-3.1 4.7-7.4 5.9-13zm56.5-52.8h27.6v31.3h30.2v-31.3h27.8v89.4h-27.8v-36.2h-30.2v36.2h-27.6v-89.4z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M271.3 159.1c0-14.6 4.1-26 12.2-34.1 8.1-8.1 19.5-12.2 34-12.2 14.9 0 26.3 4 34.4 12S364 144 364 158.4c0 10.5-1.8 19-5.3 25.7-3.4 6.6-8.7 12-15.2 15.6-6.7 3.7-15 5.6-24.9 5.6-10.1 0-18.4-1.6-25-4.8-6.8-3.4-12.4-8.7-16.1-15.2-4.1-7-6.2-15.7-6.2-26.2zm27.6.1c0 9 1.7 15.5 5 19.5 3.3 3.9 7.9 5.9 13.7 5.9 5.9 0 10.5-1.9 13.8-5.8s4.9-10.8 4.9-20.8c0-8.4-1.7-14.6-5.1-18.4-3.4-3.9-8-5.8-13.8-5.8-5.1-.2-10 2-13.4 5.9-3.4 3.9-5.1 10.4-5.1 19.5zm93.4-.1c0-14.6 4.1-26 12.2-34.1 8.1-8.1 19.5-12.2 34-12.2 14.9 0 26.4 4 34.4 12S485 144 485 158.4c0 10.5-1.8 19-5.3 25.7-3.4 6.6-8.7 12-15.2 15.6-6.7 3.7-15 5.6-24.9 5.6-10.1 0-18.4-1.6-25-4.8-6.8-3.4-12.4-8.7-16.1-15.2-4.1-7-6.2-15.7-6.2-26.2zm27.6.1c0 9 1.7 15.5 5 19.5 3.3 3.9 7.9 5.9 13.7 5.9 5.9 0 10.5-1.9 13.8-5.8 3.3-3.9 4.9-10.8 4.9-20.8 0-8.4-1.7-14.6-5.1-18.4-3.4-3.9-8-5.8-13.8-5.8-5.1-.2-10.1 2-13.4 5.9-3.4 3.9-5.1 10.4-5.1 19.5z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M482.1 114.4h27.6v67.4h43.1v22H482v-89.4z"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-37.001 420.46 67.88)",
  className: "rs_school_js_svg__st0",
  cx: 420.5,
  cy: 67.9,
  rx: 63,
  ry: 51.8
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
  id: "rs_school_js_svg__SVGID_1_",
  transform: "rotate(-37.001 420.46 67.88)",
  cx: 420.5,
  cy: 67.9,
  rx: 63,
  ry: 51.8
}))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "rs_school_js_svg__SVGID_2_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#rs_school_js_svg__SVGID_1_",
  overflow: "visible"
}))), /*#__PURE__*/React.createElement("g", {
  style: {
    clipPath: "url(#rs_school_js_svg__SVGID_2_)"
  }
}, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-37.001 420.82 68.353)",
  className: "rs_school_js_svg__st0",
  d: "M330.9-14.2h179.8v165.1H330.9z"
})), /*#__PURE__*/React.createElement("g", {
  id: "rs_school_js_svg__Layer_2_1_"
}, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "rs_school_js_svg__SVGID_3_",
  transform: "rotate(-37.001 420.82 68.353)",
  d: "M330.9-14.2h179.8v165.1H330.9z"
}))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "rs_school_js_svg__SVGID_4_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#rs_school_js_svg__SVGID_3_",
  overflow: "visible"
}))), /*#__PURE__*/React.createElement("g", {
  id: "rs_school_js_svg__Layer_1-2",
  style: {
    clipPath: "url(#rs_school_js_svg__SVGID_4_)"
  }
}, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-37.001 420.46 67.88)",
  className: "rs_school_js_svg__st0",
  cx: 420.5,
  cy: 67.9,
  rx: 63,
  ry: 51.8
})), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
  id: "rs_school_js_svg__SVGID_5_",
  transform: "rotate(-37.001 420.46 67.88)",
  cx: 420.5,
  cy: 67.9,
  rx: 63,
  ry: 51.8
}))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "rs_school_js_svg__SVGID_6_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#rs_school_js_svg__SVGID_5_",
  overflow: "visible"
}))), /*#__PURE__*/React.createElement("g", {
  style: {
    clipPath: "url(#rs_school_js_svg__SVGID_6_)"
  }
}, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-37 420.799 68.802)",
  className: "rs_school_js_svg__st0",
  d: "M357.8 17h125.9v103.7H357.8z"
})), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "rs_school_js_svg__SVGID_7_",
  transform: "rotate(-37 420.799 68.802)",
  d: "M357.8 17h125.9v103.7H357.8z"
}))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
  id: "rs_school_js_svg__SVGID_8_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#rs_school_js_svg__SVGID_7_",
  overflow: "visible"
}))), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-37.001 420.46 67.88)",
  className: "rs_school_js_svg__st5",
  cx: 420.5,
  cy: 67.9,
  rx: 63,
  ry: 51.8,
  style: {
    clipPath: "url(#rs_school_js_svg__SVGID_8_)"
  }
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-37 420.799 68.802)",
  d: "M357.8 17h125.9v103.7H357.8z",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    clipPath: "url(#rs_school_js_svg__SVGID_8_)"
  }
}), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-37.001 420.46 67.88)",
  className: "rs_school_js_svg__st7",
  cx: 420.5,
  cy: 67.9,
  rx: 63,
  ry: 51.8
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-37 420.799 68.802)",
  className: "rs_school_js_svg__st0",
  d: "M357.8 17h125.9v103.7H357.8z"
})), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "rs_school_js_svg__SVGID_9_",
  transform: "rotate(-37 420.799 68.802)",
  d: "M357.8 17h125.9v103.7H357.8z"
}))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
  id: "rs_school_js_svg__SVGID_10_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#rs_school_js_svg__SVGID_9_",
  overflow: "visible"
}))), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-37.001 420.46 67.88)",
  className: "rs_school_js_svg__st5",
  cx: 420.5,
  cy: 67.9,
  rx: 63,
  ry: 51.8,
  style: {
    clipPath: "url(#rs_school_js_svg__SVGID_10_)"
  }
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-37 420.799 68.802)",
  d: "M357.8 17h125.9v103.7H357.8z",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    clipPath: "url(#rs_school_js_svg__SVGID_10_)"
  }
}), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-37.001 420.82 68.353)",
  className: "rs_school_js_svg__st7",
  d: "M330.9-14.2h179.8v165.1H330.9z"
}))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-37.001 420.46 67.88)",
  className: "rs_school_js_svg__st7",
  cx: 420.5,
  cy: 67.9,
  rx: 63,
  ry: 51.8
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "m392.4 61.3 10-7 12.3 17.5c2.1 2.8 3.7 5.8 4.9 9.1.7 2.5.5 5.2-.5 7.6-1.3 3-3.4 5.5-6.2 7.3-3.3 2.3-6.1 3.6-8.5 4-2.3.4-4.7 0-6.9-1-2.4-1.2-4.5-2.9-6.1-5.1l8.6-8c.7 1.1 1.6 2.1 2.6 2.9.7.5 1.5.8 2.4.8.7 0 1.4-.3 1.9-.7 1-.6 1.7-1.8 1.6-3-.3-1.7-1-3.4-2.1-4.7l-14-19.7zm30 11.1 9.1-7.2c1 1.2 2.3 2.1 3.7 2.6 2 .6 4.1.2 5.8-1.1 1.2-.8 2.2-1.9 2.6-3.3.6-1.8-.4-3.8-2.2-4.4-.3-.1-.6-.2-.9-.2-1.2-.1-3.3.4-6.4 1.7-5.1 2.1-9.1 2.9-12.1 2.6-2.9-.3-5.6-1.8-7.2-4.3-1.2-1.7-1.8-3.7-1.9-5.7 0-2.3.6-4.6 1.9-6.5 1.9-2.7 4.2-5 7-6.8 4.2-2.9 7.9-4.3 11.1-4.3 3.2 0 6.2 1.5 9 4.6l-9 7.1c-1.8-2.3-5.2-2.8-7.5-1l-.3.3c-1 .6-1.7 1.5-2.1 2.6-.3.8-.1 1.7.4 2.4.4.5 1 .9 1.7.9.8.1 2.2-.3 4.2-1.2 5-2.1 8.8-3.3 11.4-3.7 2.2-.4 4.5-.2 6.6.7 1.9.8 3.5 2.2 4.6 3.9 1.4 2 2.2 4.4 2.3 6.9.1 2.6-.6 5.1-2 7.3-1.8 2.7-4.1 5-6.8 6.8-5.5 3.8-10 5.4-13.6 4.8-3.9-.6-7.1-2.6-9.4-5.5z"
}))))));

export default SvgRsSchoolJs;